export const VERSION = 1.01

export const HORIZONTAL_MARGIN_PERCENTAGE = 2.5
export const COLOUR_EASING = 100
export const FADE_SPEED = 0.01
export const TRANSITION_SPEED_DIV = 25
export const DEFAULT_FPS = 30
export const SHOW_EXPORT_BUTTON = false
export const AUTOMATON_CHANGE = 120 / 2
export const DESATURATE_SPEED = 2000
export const SHAPE_MORPH_SPEED = 0.0055
export const SNAP_DISTANCE = 0.02
